module.exports = "../../app/cells/components/commented_questions_cell.rb";